import * as yup from 'yup';

export const commonTransferOfChargeSearchCriteriaValidation: { [x: string]: any; } = {
    cntrNos: yup.array().of(yup.string()).required("Missing.").min(1, "Missing."),
    soNumber1: yup.string().required("Missing."),
    blNo1: yup.string().required("Missing."),
};

export const transferOfChargeSearchCriteriaValidation: { [x: string]: any; } = {
    ...commonTransferOfChargeSearchCriteriaValidation,
};
export const SaptTransferOfChargeSearchCriteriaValidation: { [x: string]: any; } = {
    ...commonTransferOfChargeSearchCriteriaValidation,
    serviceReferenceNo: yup.string().required("Missing."),
};

export const transferOfChargeSearchCriteriaValidationSchema = yup.object().shape(transferOfChargeSearchCriteriaValidation);
export const SaptTransferOfChargeSearchCriteriaValidationSchema = yup.object().shape(SaptTransferOfChargeSearchCriteriaValidation);
